import { render, staticRenderFns } from "./SettlementDocBoundary.vue?vue&type=template&id=6da24980&"
import script from "./SettlementDocBoundary.vue?vue&type=script&lang=js&"
export * from "./SettlementDocBoundary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports